/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientDetailsDocuments } from './HchbPatientDetailsDocuments';
import {
    HchbPatientDetailsDocumentsFromJSON,
    HchbPatientDetailsDocumentsFromJSONTyped,
    HchbPatientDetailsDocumentsToJSON,
    HchbPatientDetailsDocumentsToJSONTyped,
} from './HchbPatientDetailsDocuments';
import type { KinnserDocumentUploadAllOfLatestUpload } from './KinnserDocumentUploadAllOfLatestUpload';
import {
    KinnserDocumentUploadAllOfLatestUploadFromJSON,
    KinnserDocumentUploadAllOfLatestUploadFromJSONTyped,
    KinnserDocumentUploadAllOfLatestUploadToJSON,
    KinnserDocumentUploadAllOfLatestUploadToJSONTyped,
} from './KinnserDocumentUploadAllOfLatestUpload';
import type { HchbPatientDetailsExternalEhrPatient } from './HchbPatientDetailsExternalEhrPatient';
import {
    HchbPatientDetailsExternalEhrPatientFromJSON,
    HchbPatientDetailsExternalEhrPatientFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientToJSON,
    HchbPatientDetailsExternalEhrPatientToJSONTyped,
} from './HchbPatientDetailsExternalEhrPatient';

/**
 * Linked WellSky patient, lead documents with their upload state, and the latest upload; present once the patient exists
 * @export
 * @interface KinnserDocumentUpload
 */
export interface KinnserDocumentUpload {
    /**
     * 
     */
    external_ehr_patient?: HchbPatientDetailsExternalEhrPatient;
    /**
     * 
     */
    documents?: HchbPatientDetailsDocuments;
    /**
     * 
     */
    latest_upload?: KinnserDocumentUploadAllOfLatestUpload;
}

/**
 * Check if a given object implements the KinnserDocumentUpload interface.
 */
export function instanceOfKinnserDocumentUpload(value: object): value is KinnserDocumentUpload {
    return true;
}

export function KinnserDocumentUploadFromJSON(json: any): KinnserDocumentUpload {
    return KinnserDocumentUploadFromJSONTyped(json, false);
}

export function KinnserDocumentUploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserDocumentUpload {
    if (json == null) {
        return json;
    }
    return {
        
        'external_ehr_patient': json['external_ehr_patient'] == null ? undefined : HchbPatientDetailsExternalEhrPatientFromJSON(json['external_ehr_patient']),
        'documents': json['documents'] == null ? undefined : HchbPatientDetailsDocumentsFromJSON(json['documents']),
        'latest_upload': json['latest_upload'] == null ? undefined : KinnserDocumentUploadAllOfLatestUploadFromJSON(json['latest_upload']),
    };
}

export function KinnserDocumentUploadToJSON(json: any): KinnserDocumentUpload {
    return KinnserDocumentUploadToJSONTyped(json, false);
}

export function KinnserDocumentUploadToJSONTyped(value?: KinnserDocumentUpload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'external_ehr_patient': HchbPatientDetailsExternalEhrPatientToJSON(value['external_ehr_patient']),
        'documents': HchbPatientDetailsDocumentsToJSON(value['documents']),
        'latest_upload': KinnserDocumentUploadAllOfLatestUploadToJSON(value['latest_upload']),
    };
}

